import React from 'react';
import { ButtonDropdown, ButtonDropdownProps, Icon, Popover } from '@amzn/awsui-components-react';
import CONSTANTS from 'src/utils/constants';
import WorksheetTotal from 'src/models/tp-allocation/WorksheetTotal';
import { DAS_TOTAL_MENU_ITEMS, DasTotalRow } from './DasTotalsCells';

type DasTotalCellArgs = { row: { original: DasTotalRow }; value?: string };

export interface DasTotalsColumnsArgs {
    viewMode: string;
    /** Disables the row menu while a save is in flight. */
    saving?: boolean;
    totals: WorksheetTotal[];
    onMenuClick: (detail: ButtonDropdownProps.ItemClickDetails, total: WorksheetTotal) => void;
}

const header = (label: string) => () => <div className="cell-text-non-sortable">{label}</div>;

/** Column definitions of the Step 2 grid; columns without a Cell use the shared editable cell. */
export function getDasTotalsColumns({ viewMode, saving = false, totals, onMenuClick }: DasTotalsColumnsArgs) {
    return [
        {
            accessor: 'visibleSequence',
            Header: header('#'),
            Cell: ({ row }: DasTotalCellArgs) => {
                const total = row.original;
                return (
                    <div className={`save-status-${total.savingStatus} totalSequenceCell textCell`}>
                        <span className="sequenceCellValue">{total.visibleSequence}</span>
                    </div>
                );
            },
        },
        { accessor: 'description', Header: header('Total name') },
        {
            accessor: CONSTANTS.WORKSHEET_TOTAL_FIELDS.OVERVIEW,
            Header: <div className="headerToggle">Calculation overview &nbsp;
                <Popover className="calcOverviewPopover" dismissButton={false} position="right" size="small" triggerType="custom"
                         content="Click the expression to edit. Type '@' to display the autocomplete menu.">
                    <Icon name="status-info" size="small" variant="link" />
                </Popover>
            </div>,
        },
        {
            accessor: `${CONSTANTS.WORKSHEET_TOTAL_FIELDS.OUTPUT}Formatted`,
            Header: header('Formula output'),
            Cell: (e: DasTotalCellArgs) => <div className="cell-text">{e.value}</div>,
        },
        {
            accessor: 'actions',
            Header: header(''),
            Cell: (e: DasTotalCellArgs) => <div className="rowActions formulaOutputCell">
                {viewMode === CONSTANTS.VIEW_MODE.EDITABLE &&
                    <ButtonDropdown className={'rowContextMenu gridContextMenu dasTotalRowAction' + e.row.original.totalId}
                                    onItemClick={({ detail }) => onMenuClick(detail,
                                        totals.find((t) => t.totalId === e.row.original.totalId) || e.row.original)}
                                    items={DAS_TOTAL_MENU_ITEMS} disabled={saving} />
                }
            </div>,
        },
    ];
}
